$(document).ready(function(){


	var currentUrl = window.location.href;
  checkIdInUrl(currentUrl, '#section__');

	$('a[href^="#"], .scrollTop a').on('click', function(e){
		e.preventDefault();

		// -- Close dropdown menu --
		if ($(this).parent('li').hasClass('level--2')) {
			$('.dropdown').removeClass('open');
		}
		
		// -- Scroll to section --
		var id = $(this).attr('href');
		$('html, body').animate({
			scrollTop: $(id).offset().top - $('.header').outerHeight()
		}, 'slow');
		return false;
	});


  function checkIdInUrl(url, text){
	  if(url.indexOf(text) > -1) {
	  	var id = decodeURIComponent(window.location.hash);
			$('html, body').animate({
				scrollTop: $(id).offset().top - $('.header').outerHeight()
			}, 'slow');
	  }
  }


});